import React from "react";
import { useI18n } from "@/lib/i18n";
import { LangToggle } from "@/components/Brand";

/** Studio branding, language toggle and the step progress indicator. */
export const GalleryHeader = ({ data, steps, step, cur }) => {
  const { t } = useI18n();

  return (
    <header className="glass sticky top-0 z-40 border-b border-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-12 py-3 flex items-center justify-between gap-4">
        <div className="min-w-0">
          {data.studio_logo ? (
            <img data-testid="gallery-studio-logo" src={data.studio_logo} alt={data.studio_name} className="h-7 w-auto object-contain" />
          ) : (
            <p className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">{data.studio_name}</p>
          )}
          <p className="text-xs text-[#A8A8A8] mt-0.5 truncate">{data.code || data.title}</p>
        </div>
        <LangToggle />
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-12 pb-3" data-testid="step-progress">
        <div className="flex items-center justify-between gap-3">
          <p className="font-mono-accent text-[10px] tracking-[0.16em] uppercase text-[#D4AF37] truncate">
            {t(cur)}
          </p>
          <p className="font-mono-accent text-[10px] tracking-[0.16em] uppercase text-[#707070] shrink-0"
            data-testid="step-counter">
            {t("step_of", { n: step + 1, total: steps.length })}
          </p>
        </div>
        <div className="mt-2 h-0.5 bg-[#1E1E1E]">
          <div className="h-full bg-[#D4AF37] transition-all duration-500"
            style={{ width: `${((step + 1) / steps.length) * 100}%` }} />
        </div>
        <div className="hidden sm:flex items-center gap-3 mt-3">
          {steps.map((s, i) => (
            <span key={s} data-testid={`step-indicator-${i}`}
              className={`shrink-0 font-mono-accent text-[10px] tracking-[0.16em] uppercase ${
                i === step ? "text-[#D4AF37]" : i < step ? "text-[#6b6b6b]" : "text-[#3d3d3d]"
              }`}>
              0{i + 1} {t(s)}
            </span>
          ))}
        </div>
      </div>
    </header>
  );
};
